<template>
  <div
    class="modal fade"
    id="orderModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="orderModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="isEmpty(order.id)" class="modal-title" id="orderModalLabel">เพิ่มใบส่งสินค้าใหม่</h5>
          <h5 v-else class="modal-title" id="orderModalLabel">
            แสดงข้อมูล
            <span class="text-primary">{{ order.do_ref }}</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="!appearForm" class="well well-sm text-center">
            <i class="fa fa-cog fa-spin fa-fw"></i>
            {{ message }}
          </div>
          <form v-else id="dataForm" @submit.prevent="saveData">
            <div class="row">
              <div class="form-group col-sm-4">
                <label>ลูกค้า*</label>
                <vue-single-select
                  inputId="selected-customer"
                  v-model="selectedCustomer"
                  :options="customers"
                  option-label="name"
                  placeholder="เลือกลูกค้า"
                  :classes="{
                  wrapper: 'single-select-wrapper form-input-wrapper',
                  input: 'form-control',
                  icons: 'icons',
                  required: 'required',
                  activeClass: 'active',
                  dropdown: 'dropdown'
                }"
                ></vue-single-select>
              </div>
              <div class="form-group col-sm-2">
                <label>รหัสลูกค้า</label>
                <input
                  type="text"
                  class="form-control-plaintext bg-light"
                  :value="isEmpty(selectedCustomer) ? null : selectedCustomer.code"
                />
              </div>
              <div class="form-group col-sm-6">
                <label>ชื่อลูกค้า</label>
                <input
                  type="text"
                  class="form-control-plaintext bg-light"
                  :value="isEmpty(selectedCustomer) ? null : selectedCustomer.name"
                />
              </div>
            </div>

            <div class="form-group">
              <label>ที่อยู่ลูกค้า</label>
              <input
                type="text"
                class="form-control-plaintext bg-light"
                :value="isEmpty(selectedCustomer) ? null : selectedCustomer.address"
              />
            </div>
            <div class="row">
              <div class="form-group col-sm-4">
                <label>จังหวัด</label>
                <input
                  type="text"
                  class="form-control-plaintext bg-light"
                  :value="isEmpty(selectedCustomer) ? null : selectedCustomer.province"
                />
              </div>
              <div class="form-group col-sm-4">
                <label>เบอร์โทรศัพท์</label>
                <input
                  type="text"
                  class="form-control-plaintext bg-light"
                  :value="isEmpty(selectedCustomer) ? null : selectedCustomer.phone_number"
                />
              </div>
              <div class="form-group col-sm-4">
                <label>เลขประจำตัวผู้เสียภาษี</label>
                <input
                  type="text"
                  class="form-control-plaintext bg-light"
                  :value="isEmpty(selectedCustomer) ? null : selectedCustomer.tax_number"
                />
              </div>
            </div>

            <div class="row">
              <div v-if="!isEmpty(order.id)" class="form-group col-sm-4">
                <label>เลขที่ใบส่งสินค้า*</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="order.do_ref"
                  placeholder=""
                />
              </div>
              <div class="form-group col-sm-4">
                <label>วันที่ใบส่งสินค้า*</label>
                <v-date-picker
                  :input-props="{ placeholder: 'คลิกเพื่อเปิดปฏิทิน' }"
                  locale="th"
                  title-position="left"
                  :marks="formats"
                  :popover="{ placement: 'top', visibility: 'click' }"
                  v-model="order.do_date"
                  v-on:input="setPaymentDueDate"
                ></v-date-picker>
              </div>
              <div class="form-group col-sm-4">
                <label>วันครบกำหนดชำระเงิน</label>
                <v-date-picker
                  :input-props="{ placeholder: 'คลิกเพื่อเปิดปฏิทิน' }"
                  locale="th"
                  title-position="left"
                  :marks="formats"
                  :popover="{ placement: 'top', visibility: 'click' }"
                  v-model="order.payment_due_date"
                ></v-date-picker>
              </div>
              <div class="form-group col-sm-4">
                <label>อ้างถึง PO/NO</label>
                <input type="text" class="form-control input-sm" v-model.trim="order.po_ref" />
              </div>
            </div>

            <h5 class="mt-3 mb-2">รายการสินค้า</h5>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th style="width:150px">รหัสสินค้า</th>
                  <th>ชื่อสินค้า</th>
                  <th class="text-right" style="width:100px">ราคาต่อหน่วย</th>
                  <th class="text-right" style="width:80px">จำนวน</th>
                  <th class="text-right">หน่วย</th>
                  <th class="text-right" style="width:100px">ราคารวม</th>
                  <th style="width:60px"></th>
                </tr>
                <tr class="table-info">
                  <td></td>
                  <td class="d-flex">
                    <vue-single-select
                      inputId="selected-item"
                      v-model="selectedItem"
                      :options="items"
                      option-label="name"
                      placeholder="เลือกสินค้า"
                      class="flex-grow-1 mr-2"
                      :classes="{
                      wrapper: 'single-select-wrapper form-input-wrapper mb-0',
                      input: 'form-control form-control-sm',
                      icons: 'icons',
                      required: 'required',
                      activeClass: 'active',
                      dropdown: 'dropdown'
                    }"
                    ></vue-single-select>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      @click="addRow"
                      :disabled="selectedItem === null"
                    >เพิ่มสินค้า</button>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(orderItem, index) in order.order_items" :key="index">
                  <td class="align-middle">{{ orderItem.code }}</td>
                  <td class="align-middle">{{ orderItem.name }}</td>
                  <td>
                    <input
                      class="form-control form-control-sm text-right"
                      type="text"
                      v-model="orderItem.unit_price"
                    />
                  </td>
                  <td>
                    <input
                      class="form-control form-control-sm text-right"
                      type="text"
                      v-model="orderItem.quantity"
                    />
                  </td>
                  <td class="text-right align-middle">{{ orderItem.unit }}</td>
                  <td class="text-right align-middle">{{ numberWithCommas(orderItem.unit_price*orderItem.quantity, 2) }}</td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-danger" type="button" @click="deleteRow(index)">
                      <i class="fa fa-trash mr-1"></i>ลบ
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot style="border-top: 2px solid #dee2e6">
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>ส่วนลด</td>
                  <td><input v-model="order.discount_name" type="text" class="text-right form-control form-control-sm" style="width:120px" placeholder="ชื่อส่วนลด"></td>
                  <td class="text-right">
                    <input
                      class="form-control form-control-sm text-right"
                      type="text"
                      v-model="order.discount"
                    />
                  </td>
                  <td>บาท</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">ยอดสุทธิ</td>
                  <td class="text-right">{{ numberWithCommas(netTotal, 2) }}</td>
                  <td>บาท</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><input type="checkbox" v-model="isVat" /> มี Vat</td>
                  <td class="text-right">VAT</td>
                  <td class="text-right">{{ numberWithCommas(vat, 2)}}</td>
                  <td>บาท</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                    <strong>ยอดก่อน VAT</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ numberWithCommas(sumTotal, 2) }}</strong>
                  </td>
                  <td>
                    <strong>บาท</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </form>
        </div>
        <div class="modal-footer d-flex" v-if="appearForm">
          <button class="btn btn-danger" type="button" @click="deleteorder">
            <i class="fa fa-trash"></i>
          </button>
          <button
            class="btn btn-primary ml-auto"
            form="dataForm"
            :disabled="submitted || !valid"
          >บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSingleSelect from "vue-single-select";
import VCalendar from "v-calendar";
export default {
  components: {
    VCalendar,
    VueSingleSelect
  },
  data() {
    return {
      appearForm: false,
      message: "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่",
      submitted: false,
      customers: [],
      items: [],
      isVat: true,
      selectedCustomer: null,
      selectedItem: null,
      formats: {
        title: "MMMM YYYY",
        weekdays: "W",
        navMonths: "MMM",
        input: ["DD/MM/YYYY"],
        dayPopover: "L",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"]
      },
      order: {
        id: null,
        po_ref: null,
        do_ref:null,
        do_date: null,
        payment_due_date: null,
        total: null,
        vat: null,
        discount: 0,
        discount_name: null,
        net_total: null,
        customer_id: null,
        order_items: []
      }
    };
  },
  created() {
    // ตั้งค่าวันที่เริ่มต้น วันที่ใบส่งสินค้า และ วันครบกำหนดชำระเงิน
    this.order.do_date = new Date();
    this.order.payment_due_date = new Date(new Date().setMonth(new Date().getMonth() + 3));

    axios
      .all([axios.get("/customers"), axios.get("/items")])
      .then(
        axios.spread((customerRes, itemRes) => {
          this.customers = customerRes.data;
          this.items = itemRes.data;
        })
      )
      .catch(error => {
        alert("เกิดข้อผิดพลาด");
      });
  },
  mounted() {
    $("#orderModal").on("show.bs.modal", event => {
      this.appearForm = false;
      var button = $(event.relatedTarget);
      var id = button.data("id");

      if (id === undefined) {
        this.appearForm = true;
        return;
      }

      axios
        .get("/orders/" + id)
        .then(response => {
          let order = response.data;
          this.appearForm = true;

          if (order.vat == 0)
            this.isVat = false;

          if (order.do_date != null)
            order.do_date = new Date(order.do_date);

          if (order.payment_due_date != null)
            order.payment_due_date = new Date(order.payment_due_date);

          if (order.received_date != null)
            order.received_date = new Date(order.received_date);

          // ข้อมูลลูกค้า
          if(order.customer_id){
            this.selectedCustomer = _.find(this.customers, ['id',order.customer_id]);
          }

          this.order = { ...order };
          setTimeout(() => {
            this.order.payment_due_date = new Date(order.payment_due_date);
          }, 500);
        })
        .catch(error => console.log(error));
    });

    $("#orderModal").on("hidden.bs.modal", event => {
      this.resetForm();
    });
  },
  methods: {
    setPaymentDueDate() {
      if (this.order.do_date) {
        let date = new Date(this.order.do_date.valueOf());
        this.order.payment_due_date = new Date(date.setMonth(date.getMonth() + 3));
      }
    },
    isEmpty: str => !str || 0 === str.length,
    saveData: function() {
      this.disableForm();
      //เตรียมข้อมูล
      let formData = { ...this.order };

      if (this.order.id !== null) formData._method = "put";

      formData.order_items = _.map(formData.order_items, orderItem => {
        orderItem.total = orderItem.quantity * orderItem.unit_price;

        let newOrderItem = {
          item_id: orderItem.item_id,
          quantity: orderItem.quantity,
          unit_price: orderItem.unit_price,
          total: orderItem.total,
        }

        orderItem = newOrderItem;
        return orderItem;
      })

      formData.do_date = moment(formData.do_date).format("YYYY-MM-DD");
      formData.payment_due_date = moment(formData.payment_due_date).format("YYYY-MM-DD");

      if (this.order.received_date != null)
        formData.received_date = moment(this.order.received_date).format("YYYY-MM-DD");

      formData.customer_id = this.selectedCustomer.id;
      formData.total = this.sumTotal;
      formData.vat = this.vat;
      formData.net_total = this.netTotal;

      //ส่งข้อมูล
      axios
        .post(
          this.order.id === null ? "/orders" : "/orders/" + this.order.id,
          formData
        )
        .then(response => {
          $("#orderModal").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#orderModal").modal("hide"); //hide model
          this.$emit("update-fail");
        });
    },
    disableForm() {
      this.message = "กำลังดำเนินการ";
      this.submitted = true;
      this.appearForm = false;
    },
    resetForm() {
      this.order = {
        id: null,
        po_ref: null,
        do_ref: null,
        do_date: new Date(),
        payment_due_date: new Date(new Date().setMonth(new Date().getMonth() + 3)),
        total: null,
        vat: null,
        discount: 0,
        discount_name: null,
        net_total: null,
        customer_id: null,
        order_items: []
      };
      this.selectedCustomer = null;
      this.submitted = false;
      this.appearForm = true;
      this.message = "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่";
    },
    deleteorder() {
      if (!confirm("ยืนยันลบข้อมูลใบส่งสินค้า?")) {
        return;
      }
      axios
        .delete("/orders/" + this.order.id)
        .then(response => {
          $("#orderModal").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#orderModal").modal("hide"); //hide model
          let message = error.response.data.message;
          this.$emit("update-fail", message);
        });
      // delete-success
    },
    addRow: function() {
      this.order.order_items.push({
        item_id: this.selectedItem.id,
        code: this.selectedItem.code,
        name: this.selectedItem.name,
        unit_price: this.selectedItem.unit_price,
        unit: this.selectedItem.unit,
        quantity: 1
      });
      this.selectedItem = null;
    },
    deleteRow: function(index) {
      this.$delete(this.order.order_items, index);
    },
    numberWithCommas: (x, y = 0) =>
      x !== null
        ? x.toLocaleString(undefined, {
            minimumFractionDigits: y,
            maximumFractionDigits: 2
          })
        : x,
  },
  computed: {
    valid: function() {
      return (
        !this.isEmpty(this.order.do_date) &&
        !this.isEmpty(this.order.order_items) &&
        !this.isEmpty(this.selectedCustomer)
      );
    },
    netTotal: function() {
      return  _.round(_.reduce(this.order.order_items, function(sum, order_item){ return sum + parseFloat(order_item.unit_price * order_item.quantity); }, 0) - this.order.discount, 2);
    },
    vat: function() {
      return _.round(this.netTotal - this.sumTotal, 2);
    },
    sumTotal: function() {
      return this.isVat ? _.round(this.netTotal / 1.07, 2) : this.netTotal;
    },
  },
};
</script>
